/* eslint-disable max-len */
import axiosClient from './axiosClient'

const dashBoardApi = {
  getDataDashboard: (groupId, range, data = {}) => {
    const params = {
      groupId,
      range,
      start: data?.start,
      end: data?.end,
      eid: data?.eid,
      status: data?.status,
    }
    Object.keys(params).forEach((key) => {
      if (params[key] === undefined || params[key] === null) {
        delete params[key]
      }
    })
    return axiosClient.get('/get-overview-section', { params })
  },
  getDataGroupDashboard: (groupId, range, data = {}) => {
    const params = {
      groupId,
      range,
      start: data?.start,
      end: data?.end,
      eid: data?.eid,
      status: data?.status,
    }
    Object.keys(params).forEach((key) => {
      if (params[key] === undefined || params[key] === null) {
        delete params[key]
      }
    })
    return axiosClient.get('/get-overview-section-admin', { params })
  },
  getEventsSection: (data) => {
    const url = `/get-events-section?groupId=${data?.groupId}`
    return axiosClient.get(url)
  },
  remindBuyerPayment: (data) => {
    const url = '/remind-buyer-payment'
    return axiosClient.post(url, data)
  },
}

export default dashBoardApi
